import isEmpty from "../isEmpty";

/**
 * Validate member form data before passing to backend
 *
 * @param {object} state - AddMember or EditMember component state
 * @param {boolean} isEdit - true if editing an existing member
 * @returns {object} error state, type and message
 * @author Brittany Deventer
 *
 */

export default (state, isEdit) => {
  if (isEmpty(state)) {
    console.error("Member Validation: Cannot validate an empty object.");
  } else {
    if (state.email.length === 0) {
      return {
        error: true,
        errorType: ["emailErr"],
        msg: "Email is required",
      };
    }

    if (!/^[A-Z0-9._%+-]+@[A-Z0-9.-]+\.[A-Z]{2,4}$/i.test(state.email)) {
      return {
        error: true,
        errorType: ["emailErr"],
        msg: "Invalid Email",
      };
    }

    if (state.email !== state.confirmEmail) {
      return {
        error: true,
        errorType: ["emailErr"],
        msg: "Email does not match",
      };
    }

    if (!isEdit) {
      if (state.password.length === 0) {
        return {
          error: true,
          errorType: ["pwErr"],
          msg: "Invalid Password",
        };
      }

      if (state.password.length < 8) {
        return {
          error: true,
          errorType: ["pwErr"],
          msg: "Password must be 8 characters or more",
        };
      }

      if (state.password !== state.confirmPassword) {
        return {
          error: true,
          errorType: ["pwErr"],
          msg: "Passwords do not match",
        };
      }
    } else {
      // only check length and match if a new password is present
      if (state.password.length > 0) {
        if (state.password.length < 8) {
          return {
            error: true,
            errorType: ["pwErr"],
            msg: "Password must be 8 characters or more",
          };
        }

        if (state.password !== state.confirmPassword) {
          return {
            error: true,
            errorType: ["pwErr"],
            msg: "Passwords do not match",
          };
        }
      }
    }

    if (state.firstName.length === 0) {
      return {
        error: true,
        errorType: ["fNameErr"],
        msg: "First name required",
      };
    }

    if (state.lastName.length === 0) {
      return {
        error: true,
        errorType: ["lNameErr"],
        msg: "Last name required",
      };
    }

    if (state.selectedLocIds.length === 0) {
      return {
        error: true,
        errorType: ["locErr"],
        msg: "Location required",
      };
    } else if (state.service === true) {
      // make sure a service location is selected
      const selectedServiceLocations = state.locations
        .filter((location) =>
          state.selectedLocIds.includes(location.LocationId)
        )
        .filter((location) => location.OrganizationId === 0);

      if (selectedServiceLocations.length === 0) {
        return {
          error: true,
          errorType: ["serviceLocErr", "locErr"],
          msg: "Service members must be a member of a service location",
        };
      }
    } else if (state.service === false) {
      // make sure no service locations are selected
      const selectedServiceLocations = state.locations
        .filter((location) =>
          state.selectedLocIds.includes(location.LocationId)
        )
        .filter((location) => location.OrganizationId === 0);

      if (selectedServiceLocations.length > 0) {
        return {
          error: true,
          errorType: ["serviceLocErr", "locErr"],
          msg: "Service locations are for service members only",
        };
      }
    }
  }

  // otherwise, no errors
  return { error: false, errorType: [""], msg: "" };
};



// WEBPACK FOOTER //
// ./src/lib/validation/memberValidation.js